<button *ngIf="isAdmin" class="addButton" mat-fab color="warn" (click)="addOpen()">
  <mat-icon>add</mat-icon>
</button>
<div class="root">
  <div class="searchBar">
    <mat-form-field appearance="outline">
      <input
              (keyup)="doFilter($event.target['value'])"
              matInput
              placeholder="Filtra un open por nombre.."
              type="search"
      />
    </mat-form-field>
  </div>
  <ng-container class="active_OpenSpaces" *ngIf="isAdmin">
    <h2 mat-dialog-title>OpenSpace’s</h2>
    <table aria-describedby="listOfActiveOpenSpaces"
           mat-table
           [dataSource]="activeOpenSpaces"
           class="mat-elevation-z8"
           matSort
           #hBSort="matSort"
    >
      <ng-container matColumnDef="name">
        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>
          Seleccionar Open
        </th>
        <td
                class="name"
                mat-cell
                *matCellDef="let element"
                (click)="selectOpenSpaceName(element.id)"
        >
          {{ element.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="eventDate">
        <th scope="col" mat-header-cell *matHeaderCellDef>Fecha del evento</th>
        <td mat-cell *matCellDef="let element">
          {{ element["eventDate"].toString() | date:'dd/MM/yyyy' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="maxVotes">
        <th scope="col" mat-header-cell *matHeaderCellDef>Max. votos</th>
        <td mat-cell *matCellDef="let element">{{ element["maxVotes"] }}</td>
      </ng-container>
      <ng-container matColumnDef="showVotes">
        <th scope="col" mat-header-cell *matHeaderCellDef>Mostrar total de votos</th>
        <td mat-cell *matCellDef="let element">
          {{ element["showVotes"] ? "SI" : "NO" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="showProposer">
        <th scope="col" mat-header-cell *matHeaderCellDef>Mostrar proponentes</th>
        <td mat-cell *matCellDef="let element">
          {{ element["showProposer"] ? "SI" : "NO" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th scope="col" mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let element">
          <mat-icon (click)="editOpen(element)">edit</mat-icon>
          <mat-icon (click)="viewOpen(element)">visibility</mat-icon>
          <mat-icon (click)="downloadOpen(element)">download</mat-icon>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-error class="errors" *ngIf="noActiveOpens"
    >No se encontraron Open's <strong>vigentes</strong></mat-error
    >
  </ng-container>
  <h2 mat-dialog-title>Finalizados</h2>
  <table aria-describedby="listOfInactiveOpenSpaces"
         mat-table
         [dataSource]="inactiveOpenSpaces"
         class="mat-elevation-z8"
         matSort
         #sBSort="matSort"
  >
    <ng-container matColumnDef="name">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>
        Seleccionar Open
      </th>
      <td
              class="name"
              mat-cell
              *matCellDef="let element"
              (click)="selectOpenSpaceName(element.id)"
      >
        {{ element.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="eventDate">
      <th scope="col" mat-header-cell *matHeaderCellDef>Fecha del evento</th>
      <td mat-cell *matCellDef="let element">
        {{ element["eventDate"].toString() | date:'dd/MM/yyyy' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="maxVotes">
      <th scope="col" mat-header-cell *matHeaderCellDef>Max. votos</th>
      <td mat-cell *matCellDef="let element">{{ element["maxVotes"] }}</td>
    </ng-container>
    <ng-container matColumnDef="showVotes">
      <th scope="col" mat-header-cell *matHeaderCellDef>Mostrar total de votos</th>
      <td mat-cell *matCellDef="let element">
        {{ element["showVotes"] ? "SI" : "NO" }}
      </td>
    </ng-container>
    <ng-container matColumnDef="showProposer">
      <th scope="col" mat-header-cell *matHeaderCellDef>Mostrar proponentes</th>
      <td mat-cell *matCellDef="let element">
        {{ element["showProposer"] ? "SI" : "NO" }}
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th scope="col" mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let element">
        <mat-icon (click)="viewOpen(element)">visibility</mat-icon>
        <mat-icon (click)="downloadOpen(element)" *ngIf="isAdmin">download</mat-icon>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumnsEnded"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsEnded"></tr>
  </table>

  <mat-error class="errors" *ngIf="noInactiveOpens"
  >No se encontraron Open's <strong>finalizados</strong></mat-error
  >
</div>
